import { mapActions, mapState, mapGetters } from 'vuex';
import slideAnimation from 'mixins/slideAnimation';
import DocumentResultGroup from 'components/product-sheets/DocumentResultGroup.vue';
import MobileDocumentResultGroup from 'components/product-sheets/mobile/DocumentResultGroup.vue';
import ResultStateIndicators from 'components/ResultStateIndicators.vue';
import { isAfter, parseISO } from 'date-fns';

export default {
  props: {
    pigment: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      assetsVisible: false
    };
  },
  mixins: [slideAnimation],
  computed: {
    ...mapState(['basket', 'favorites']),
    ...mapGetters(['activeTab', 'isMobile', 'basketIds']),
    ...mapState('user', ['activeUser']),
    ...mapGetters(['isMySheets']),
    resultGroupComponent() {
      return this.isMobile ? MobileDocumentResultGroup : DocumentResultGroup;
    },
    groupedAssets() {
      const assets = {};

      this.pigment.assets.forEach((asset) => {
        if (!Array.isArray(assets[asset.type])) assets[asset.type] = [];
        assets[asset.type].push(asset);
      });

      return assets;
    },
    idsInBasket() {
      return this.pigment.assets.filter((asset) => this.basketIds.has(asset.id));
    },
    isInBasket() {
      return this.idsInBasket.length === this.pigment.assets.length;
    },
    partiallyInBasket() {
      return this.idsInBasket.length > 0;
    },
    productFavorite() {
      return this.favorites.find((s) => s.productId === this.pigment.prd);
    },
    isFavored() {
      if (!this.productFavorite) return false;

      if (!this.productFavorite.documentTypes || !Array.isArray(this.productFavorite.documentTypes)) return true;

      return this.productFavorite.documentTypes.length === 0;
    },
    isPartiallyFavored() {
      if (!this.productFavorite) return false;

      if (!this.productFavorite.documentTypes || !Array.isArray(this.productFavorite.documentTypes)) return true;

      return this.productFavorite.documentTypes.length > 0;
    },
    favoriteStateIcon() {
      if (this.isFavored) return ['fas', 'star'];

      return this.isPartiallyFavored ? ['fas', 'star-half-alt'] : ['far', 'star'];
    },
    hasNewDocuments() {
      if (!this.activeUser || !this.activeUser.previousLogin) {
        return false;
      }

      const newVersions = this.pigment.assets.filter(
        (asset) => isAfter(parseISO(asset.createdDate), parseISO(this.activeUser.previousLogin)) && asset.isRootVersion
      );

      return newVersions.length > 0;
    },
    hasNewDocumentVersions() {
      if (!this.activeUser || !this.activeUser.previousLogin) {
        return false;
      }

      const newVersions = this.pigment.assets.filter(
        (asset) => isAfter(parseISO(asset.createdDate), parseISO(this.activeUser.previousLogin)) && !asset.isRootVersion
      );

      return newVersions.length > 0;
    }
  },
  components: { DocumentResultGroup, ResultStateIndicators },
  methods: {
    ...mapActions(['addToBasket', 'removeFromBasket', 'saveFavorite', 'deleteFavorite']),
    showAssets() {
      this.assetsVisible = true;
    },
    hideAssets() {
      this.assetsVisible = false;
    },
    toggleAssets() {
      if (this.assetsVisible) this.hideAssets();
      else this.showAssets();
    },
    toggleBasket() {
      if (!this.isInBasket) this.addToBasket(this.pigment.assets);
      else this.removeFromBasket(this.pigment.assets);
    },
    toggleFavorite() {
      if (this.isFavored || this.activeTab === 'mysheets') this.removeFavorite();
      else this.addFavorite();
    },
    addFavorite() {
      this.saveFavorite({ productId: this.pigment.prd, documentTypes: [] });
    },
    removeFavorite() {
      this.deleteFavorite(this.productFavorite.id);
    }
  }
};
